export const STATUS_LABELS = {
  draft: "Draft",
  in_review: "In Review",
  approved: "Approved",
  live: "Live",
  rejected: "Rejected",
  takedown: "Takedown",
};

export default function StatusPill({ status }) {
  const label = STATUS_LABELS[status] || status;
  const cls = `pill pill-${status.replace("_", "-")}`;
  return <span className={cls} data-testid={`status-pill-${status}`}>{label}</span>;
}
